import { render, staticRenderFns } from "./mesbrasilconsultor.vue?vue&type=template&id=5f7e1b0a&scoped=true"
import script from "./mesbrasilconsultor.vue?vue&type=script&lang=js"
export * from "./mesbrasilconsultor.vue?vue&type=script&lang=js"
import style0 from "./mesbrasilconsultor.vue?vue&type=style&index=0&id=5f7e1b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7e1b0a",
  null
  
)

export default component.exports